import { render, staticRenderFns } from "./ResultstypeDocument.vue?vue&type=template&id=401c4e8c&"
import script from "./ResultstypeDocument.vue?vue&type=script&lang=js&"
export * from "./ResultstypeDocument.vue?vue&type=script&lang=js&"
import style0 from "./ResultstypeDocument.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports